var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5858_991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.936066 1.85352L3.09985 15.4347",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51905 9.22655L2.41247 2.31451C2.84306 1.63886 4.4621 0.383046 7.96964 1.21312C9.89232 1.66812 11.2546 1.75097 12.2539 1.57964C12.9095 1.46723 13.4043 1.24603 13.7926 0.95851C14.1581 3.39505 14.7409 6.82098 15.0361 8.51194C14.9119 8.61528 14.72 8.73377 14.4563 8.84727C14.1008 9.00026 13.6454 9.13101 13.1232 9.20255C12.0789 9.34564 10.7929 9.24871 9.5333 8.64912C7.07099 7.47704 4.76587 8.36964 3.51905 9.22655Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5858_991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOutline);
export default __webpack_public_path__ + "static/media/flag-outline.719d91d0b3d3bf979e8ea89ea335d341.svg";
export { ForwardRef as ReactComponent };